const initialState = {
  toggle_header: false,
  customerdata: [],
  userlist_data: [],
  layoutstyledata: localStorage.getItem("layoutStyling"),
  user_infos: [],
  user_location: [],
  current_location: {},
  products: [],
  current_invoice: [],
  invoice_list: [],
  employees: [],
  eventTypes: [],
  printerParams: {
    printerMac: localStorage.getItem("printerMac") || "",
    printerName: localStorage.getItem("printerName") || "",
  },
  expenseTypes: [],
  cashSession: {
    session: null,
    metrics: null,
  },
};

export default initialState;
